var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"title":"Monthly Statements"}},[_c('monthly-statement-activity',{attrs:{"data-obj":_vm.dataObj}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }